import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Avatar,
} from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import CallIcon from "@mui/icons-material/Call";
import SecurityIcon from "@mui/icons-material/Security";
import { Link as RouterLink } from "react-router-dom";

const featuredProducts = [
  {
    id: 1,
    title: "Bulk Messaging Gateway",
    description:
      "High-volume SMS platform with 1M+ per minute capacity, real-time DLR, and multi-operator routing.",
    icon: <MessageIcon />,
    color: "#1976d2",
  },
  {
    id: 2,
    title: "Voice Communications Platform",
    description:
      "Cloud-hosted voice platform with IVR builder, call bridging, and TTS/ASR capabilities.",
    icon: <CallIcon />,
    color: "#f50057",
  },
  {
    id: 3,
    title: "SMS Firewall",
    description:
      "Advanced telecom-grade firewall for blocking grey routes, SIM box activity, and bypass traffic.",
    icon: <SecurityIcon />,
    color: "#00c853",
  },
];

const FeaturedProducts = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: "white" }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 6, textAlign: "center" }}>
          <Typography
            variant="h2"
            component="h2"
            color="text.primary"
            sx={{ mb: 2, fontWeight: 600 }}
          >
            Our Solutions
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ maxWidth: 700, mx: "auto" }}
          >
            Innovative telecom technologies designed for scale, security, and
            seamless integration
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {featuredProducts.map((product) => (
            <Grid item xs={12} md={4} key={product.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 20px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Box sx={{ display: "flex", mb: 2 }}>
                    <Avatar
                      sx={{
                        bgcolor: product.color,
                        width: 56,
                        height: 56,
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      }}
                    >
                      {product.icon}
                    </Avatar>
                  </Box>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h3"
                    sx={{ mb: 2, fontWeight: 600 }}
                  >
                    {product.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" paragraph>
                    {product.description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 3, pt: 0 }}>
                  <Button
                    component={RouterLink}
                    to="/products"
                    size="medium"
                    color="primary"
                  >
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            component={RouterLink}
            to="/products"
            sx={{ mt: 2, px: 4 }}
          >
            View All Solutions
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default FeaturedProducts;
